// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___1D3sZ","successCheck":"styles-module__successCheck___3_KpU","ssrContainer":"styles-module__ssrContainer___19bNT"};